import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {Message} from '../_metronic/helpers'
import {AUTH_LOCAL_STORAGE_KEY} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'
let isLoggingOut = false
let isError = false
let userMessage = async () => {
  if (sessionStorage.getItem('isLoggedIn') !== 'true' || isLoggingOut) return

  isLoggingOut = true
  Swal.fire({
    icon: 'warning',
    title: 'Your session is no longer active. Please sign in again.',
    heightAuto: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading()
    },
  })
  setTimeout(() => {
    sessionStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
    sessionStorage.removeItem('currentUserRole')
    sessionStorage.removeItem('isLoggedIn')
    sessionStorage.removeItem('isUserLoggedOut')
    const frontendPath = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
    window.location.replace(`${window.location.origin}${frontendPath}/login`)
    Swal.close()
    isLoggingOut = false
  }, 1200)
}
let getContent = (contentNotNeeded: boolean | undefined, token: string | null, tenant) => {
  let header = {}
  if (contentNotNeeded) {
    header = {headers: {Authorization: `Bearer ${token}`}}
  } else {
    header = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        // 'X-tenant-Id': `${tenant}`,
      },
    }
  }
  return header
}
let getResponse = async (response: any, url: string, isMessageRequired: boolean) => {
  let responseJson: any = await response.json()
  if (responseJson.statusCode === 401) {
    void userMessage()
    return responseJson
  } else {
    if (![200, 201, 202].includes(responseJson.statusCode) && isMessageRequired !== false) {
      Message(responseJson.message, 'error')
    } else if ([200, 201, 202].includes(responseJson.statusCode) && isMessageRequired !== false) {
      toast.success(responseJson.message)
    }
    return responseJson
  }
}
let getError = async (url: string, error?: any) => {
  const friendly = {
    statusCode: 503,
    message: 'Something went wrong. Please check your connection and try again.',
    data: null,
  }

  if (error) {
    const msg = String(error?.message || '')
    if (msg.includes('Failed to fetch') || msg.includes('NetworkError') || msg.includes('ERR_NETWORK')) {
      if (!isError) {
        isError = true
        Swal.fire({
          icon: 'warning',
          title: friendly.message,
          heightAuto: false,
          confirmButtonText: 'OK',
          allowOutsideClick: true,
          allowEscapeKey: true,
        }).then(() => {
          isError = false
        })
      }
      return friendly
    }
    // Non-network error fallback
    return friendly
  } else {
    Swal.fire({
      icon: 'warning',
      title: friendly.message,
      heightAuto: false,
      confirmButtonText: 'OK',
      allowOutsideClick: true,
      allowEscapeKey: true,
    })
    return friendly
  }
}
export const api = {
  // Add other HTTP methods as needed
  get: async (
    url: string,
    token: string | null,
    tenant: string | null,
    isMessageRequired: boolean,
    options?: Object,
    contentNotNeeded?: boolean
  ) => {
    let header = getContent(contentNotNeeded, token, tenant)
    let internetConnection = window.navigator.onLine ? true : false
    if (internetConnection) {
      return await fetch(API_BASE_URL + url, {
        method: 'GET',
        ...header,
        ...options,
      })
        .then(async (response) => {
          return getResponse(response, url, isMessageRequired)
        })
        .catch((error) => {
          // Handle response error
          return getError(url, error)
        })
    } else {
      getError(url)
    }
  },
  post: async (
    url: string,
    token: string | null,
    tenant: string | null,
    options: Object,
    isMessageRequired: boolean,
    contentNotNeeded?: boolean
  ) => {
    let header = getContent(contentNotNeeded, token, tenant)
    let internetConnection = window.navigator.onLine ? true : false
    if (internetConnection) {
      return await fetch(API_BASE_URL + url, {
        method: 'POST',
        ...header,
        ...options,
      })
        .then(async (response) => {
          return getResponse(response, url, isMessageRequired)
        })
        .catch((error) => {
          // Handle response error
          return getError(url, error)
        })
    } else {
      getError(url)
    }
  },
  put: async (
    url: string,
    token: string | null,
    tenant: string | null,
    options: Object,
    isMessageRequired: boolean,
    contentNotNeeded?: boolean
  ) => {
    let header = getContent(contentNotNeeded, token, tenant)
    let internetConnection = window.navigator.onLine ? true : false
    if (internetConnection) {
      return await fetch(API_BASE_URL + url, {
        method: 'PUT',
        ...header,
        ...options,
      })
        .then(async (response) => {
          return getResponse(response, url, isMessageRequired)
        })
        .catch((error) => {
          // Handle response error
          return getError(url, error)
        })
    } else {
      getError(url)
    }
  },
  patch: async (
    url: string,
    token: string | null,
    tenant: string | null,
    options: Object,
    isMessageRequired: boolean,
    contentNotNeeded?: boolean
  ) => {
    let header = getContent(contentNotNeeded, token, tenant)
    let internetConnection = window.navigator.onLine ? true : false
    if (internetConnection) {
      return await fetch(API_BASE_URL + url, {
        method: 'PATCH',
        ...options,
        ...header,
      })
        .then(async (response) => {
          return getResponse(response, url, isMessageRequired)
        })
        .catch((error) => {
          // Handle response error
          return getError(url, error)
        })
    } else {
      getError(url)
    }
  },
  delete: async (
    url: string,
    token: string | null,
    tenant: string | null,
    isMessageRequired: boolean,
    options?: Object,
    contentNotNeeded?: boolean
  ) => {
    let header = getContent(contentNotNeeded, token, tenant)
    const hasBody = !!(options && typeof options === 'object' && 'body' in (options as Record<string, unknown>))
    if (!contentNotNeeded && !hasBody) {
      header = { headers: { Authorization: `Bearer ${token}` } }
    }

    let internetConnection = window.navigator.onLine ? true : false
    if (internetConnection) {
      return await fetch(API_BASE_URL + url, {
        method: 'DELETE',
        ...header,
        ...options,
      })
        .then(async (response) => {
          return getResponse(response, url, isMessageRequired)
        })
        .catch((error) => {
          // Handle response error
          return getError(url, error)
        })
    } else {
      getError(url)
    }
  },
}
